import { v4 as uuidv4 } from 'uuid';
import { types } from '../actions/constFromApi';

const initialState = {
  functionsDirections: [],
  industries: [],
  contractTypes: [],
  filterPeriods: [],
  currencies: null,
  clients: null,
  worktypes: null
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case types.GET_CONSTATNTS_REJECTED:
      return { ...state };
    case types.GET_CONSTATNTS_FULFILLED:
      return {
        ...state,
        functionsDirections: [
          ...action.payload.functionsDirections.map((func) => ({
            label: func.Name,
            value: func.Name,
            key: func.Id,
            JobFunctionId: func.Id
          }))
        ],
        industries: [
          ...action.payload.industries.map((industry) => ({
            label: industry.Name,
            value: industry.Name,
            key: industry.Id,
            IndustryId: industry.Id
          }))
        ],
        currencies: [
          ...action.payload.currencies.map((currency) => ({
            label: currency.Currency,
            value: currency.Currency,
            key: currency.Id
          }))
        ],
        contractTypes: [
          ...action.payload.contractTypes.map((type) => ({
            label: type.TypesName,
            value: type.TypesName?.toLowerCase(),
            key: type.Id
          }))
        ],
        filterPeriods: [
          ...action.payload.filterPeriods.map((period) => ({
            label: period.DatePosted,
            value: period.Value,
            key: period.Id
          }))
        ],
        clients: [
          ...action.payload.clients.map((client) => ({
            label: client.ClientName,
            value: client.Id,
            key: client.Id
          }))
        ],
        worktypes: [
          ...action.payload.worktypes.map((type) => ({
            label: type.Name,
            value: type.Id,
            key: type.Id
          }))
        ],
        expensetypes: [
          ...action.payload.expensetypes.map((type) => ({
            label: type.Name,
            value: type.Id,
            key: type.Id
          }))
        ],
        workLocationType: [
          {
            label: 'On-site',
            value: '0',
            key: 'On-site'
          },
          {
            label: 'Remote',
            value: '1',
            key: 'Remote'
          }
        ]
      };
    case types.GET_PLACEMENTS_CONSTANTS_FULFILLED:
      return {
        ...state,
        placements: [
          ...action.payload.placements.map((placement) => ({
            JobTitle: placement.JobTitle,
            JobId: placement.JobId,
            Id: placement.Id,
            key: placement.Id,
            PoNumber: placement.PoNumber,
            Frequency: placement.Frequency,
            RateType: placement.RateType,
            IsSplitApprovalFlow: placement.IsSplitApprovalFlow,
            PayCurrency: placement.PayCurrency,
            startDate: placement.PayrollStartDate,
          }))
        ]
      };
    default:
      return state;
  }
}
